import React from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Badge,
    Box,
    Button,
} from '@mui/material';
import {
    Notifications,
    Menu as MenuIcon,
} from '@mui/icons-material';

interface HeaderProps {
    onMenuClick: () => void;
}

const Topbar: React.FC<HeaderProps> = ({ onMenuClick }) => {
    return (
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={onMenuClick}
                    edge="start"
                    sx={{ mr: 2 }}
                >
                    <MenuIcon />
                </IconButton>

                <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                    Painel Sysprojud
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                    <IconButton color="inherit">
                        <Badge badgeContent={4} color="error">
                            <Notifications />
                        </Badge>
                    </IconButton>

                    <Button color="inherit" sx={{ ml: 1 }}>
                        Login
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Topbar;